module.exports = __webpack_public_path__ + "img/policy-accordion.d75755c9.webp";